exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contentBox[data-v-1dfc0884] {\n  padding: 0 0.104167rem;\n  text-align: center;\n}\n.contentBox .el-table--border th[data-v-1dfc0884],\n.contentBox .el-table--border td[data-v-1dfc0884] {\n  border-right: none;\n}\n.span50[data-v-1dfc0884] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.span50 li[data-v-1dfc0884] {\n  flex: 1;\n}\n.span50 i[data-v-1dfc0884] {\n  font-size: 0.114583rem;\n}", ""]);

// exports
